import { ThemeProvider } from '@taxdown/piccolo-web';
import { GlobalStyle } from './GlobalStyle';

const Theme = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <ThemeProvider>
    <GlobalStyle />
    {children}
  </ThemeProvider>
);

export default Theme;
